!(function () {
  var e = {
      314: function () {
        !(function () {
          if ("function" == typeof window.CustomEvent) return !1;
          function e(e, t) {
            t = t || { bubbles: !1, cancelable: !1, detail: void 0 };
            var s = document.createEvent("CustomEvent");
            return (s.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), s);
          }
          ((e.prototype = window.Event.prototype), (window.CustomEvent = e));
        })();
      },
      768: function () {
        (Element.prototype.matches ||
          (Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector),
          Element.prototype.closest ||
            (Element.prototype.closest = function (e) {
              var t = this;
              do {
                if (Element.prototype.matches.call(t, e)) return t;
                t = t.parentElement || t.parentNode;
              } while (null !== t && 1 === t.nodeType);
              return null;
            }));
      },
    },
    t = {};
  function s(n) {
    var r = t[n];
    if (void 0 !== r) return r.exports;
    var i = (t[n] = { exports: {} });
    return (e[n](i, i.exports, s), i.exports);
  }
  !(function () {
    "use strict";
    const e = (e) => {
        const t = "header-sticky",
          s = document.querySelector('[data-js*="header-sticky"]');
        if (!s) return;
        const n = s.parentNode.getBoundingClientRect(),
          r = void 0 !== window.pageXOffset,
          i = "CSS1Compat" === (document.compatMode || ""),
          o = r
            ? window.pageYOffset
            : i
              ? document.documentElement.scrollTop
              : document.body.scrollTop,
          a = r
            ? window.pageXOffset
            : i
              ? document.documentElement.scrollLeft
              : document.body.scrollLeft;
        (o > o + n.top
          ? s.classList.contains(t) ||
            (document.body.classList.add(t), s.classList.add(t))
          : s.classList.contains(t) &&
            (document.body.classList.remove(t), s.classList.remove(t)),
          s.classList.contains(t) &&
            (s.style.left = a > 0 ? -1 * a + "px" : ""));
      },
      t = "undefined" != typeof window,
      n = t ? window : null,
      r = t ? document : null,
      i = 0,
      o = 1,
      a = 2,
      l = 3,
      c = 4,
      u = 0,
      d = 1,
      h = 2,
      p = 3,
      m = 0,
      _ = 1,
      f = 2,
      g = { replace: 0, none: 1, blend: 2 },
      y = Symbol(),
      v = Symbol(),
      b = Symbol(),
      T = Symbol(),
      w = (Symbol(), Symbol()),
      N = 1e-11,
      k = 1e12,
      C = 1e3,
      S = "",
      L = (() => {
        const e = new Map();
        return (
          e.set("x", "translateX"),
          e.set("y", "translateY"),
          e.set("z", "translateZ"),
          e
        );
      })(),
      E = [
        "translateX",
        "translateY",
        "translateZ",
        "rotate",
        "rotateX",
        "rotateY",
        "rotateZ",
        "scale",
        "scaleX",
        "scaleY",
        "scaleZ",
        "skew",
        "skewX",
        "skewY",
        "matrix",
        "matrix3d",
        "perspective",
      ],
      D = E.reduce((e, t) => ({ ...e, [t]: t + "(" }), {}),
      x = () => {},
      A = /(^#([\da-f]{3}){1,2}$)|(^#([\da-f]{4}){1,2}$)/i,
      O = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i,
      q =
        /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/i,
      I =
        /hsl\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*\)/i,
      M =
        /hsla\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/i,
      R = /[-+]?\d*\.?\d+(?:e[-+]?\d)?/gi,
      $ = /^([-+]?\d*\.?\d+(?:e[-+]?\d+)?)([a-z]+|%)$/i,
      B = /([a-z])([A-Z])/g,
      j = /(\w+)(\([^)]+\)+)/g,
      P = /var\(\s*(--[\w-]+)(?:\s*,\s*([^)]+))?\s*\)/,
      U = {
        id: null,
        keyframes: null,
        playbackEase: null,
        playbackRate: 1,
        frameRate: 120,
        loop: 0,
        reversed: !1,
        alternate: !1,
        autoplay: !0,
        persist: !1,
        duration: C,
        delay: 0,
        loopDelay: 0,
        ease: "out(2)",
        composition: g.replace,
        modifier: (e) => e,
        onBegin: x,
        onBeforeUpdate: x,
        onUpdate: x,
        onLoop: x,
        onPause: x,
        onComplete: x,
        onRender: x,
      },
      z = { current: null, root: r },
      X = { defaults: U, precision: 4, timeScale: 1, tickThreshold: 200 },
      Y = { version: "4.2.2", engine: null };
    t && (n.AnimeJS || (n.AnimeJS = []), n.AnimeJS.push(Y));
    const V = (e) => e.replace(B, "$1-$2").toLowerCase(),
      Z = (e, t) => 0 === e.indexOf(t),
      F = Date.now,
      H = Array.isArray,
      J = (e) => e && e.constructor === Object,
      Q = (e) => "number" == typeof e && !isNaN(e),
      W = (e) => "string" == typeof e,
      G = (e) => "function" == typeof e,
      K = (e) => void 0 === e,
      ee = (e) => K(e) || null === e,
      te = (e) => t && e instanceof SVGElement,
      se = (e) => A.test(e),
      ne = (e) => Z(e, "rgb"),
      re = (e) => Z(e, "hsl"),
      ie = (e) => !X.defaults.hasOwnProperty(e),
      oe = ["opacity", "rotate", "overflow", "color"],
      ae = Math.pow,
      le = Math.sqrt,
      ce = Math.sin,
      ue = Math.cos,
      de = (Math.abs, Math.exp, Math.ceil, Math.floor),
      he = Math.asin,
      pe = (Math.max, Math.atan2, Math.PI),
      me = Math.round,
      _e = (e, t, s) => (e < t ? t : e > s ? s : e),
      fe = {},
      ge = (e, t) => {
        if (t < 0) return e;
        if (!t) return me(e);
        let s = fe[t];
        return (s || (s = fe[t] = 10 ** t), me(e * s) / s);
      },
      ye = (e, t, s) => e + (t - e) * s,
      ve = (e) => (e === 1 / 0 ? k : e === -1 / 0 ? -k : e),
      be = (e) => (e <= N ? N : ve(ge(e, 11))),
      Te = (e) => (H(e) ? [...e] : e),
      we = (e, t, s, n = "_prev", r = "_next") => {
        let i = e._head,
          o = r;
        for (s && ((i = e._tail), (o = n)); i; ) {
          const e = i[o];
          (t(i), (i = e));
        }
      },
      Ne = (e, t, s = "_prev", n = "_next") => {
        const r = t[s],
          i = t[n];
        (r ? (r[n] = i) : (e._head = i),
          i ? (i[s] = r) : (e._tail = r),
          (t[s] = null),
          (t[n] = null));
      },
      ke = (e, t, s, n = "_prev", r = "_next") => {
        let i = e._tail;
        for (; i && s && s(i, t); ) i = i[n];
        const o = i ? i[r] : e._head;
        (i ? (i[r] = t) : (e._head = t),
          o ? (o[n] = t) : (e._tail = t),
          (t[n] = i),
          (t[r] = o));
      };
    function Ce(e) {
      const t = W(e) ? z.root.querySelectorAll(e) : e;
      if (t instanceof NodeList || t instanceof HTMLCollection) return t;
    }
    function Se(e) {
      const s = (function (e) {
          if (ee(e)) return [];
          if (!t) return (H(e) && e.flat(1 / 0)) || [e];
          if (H(e)) {
            const t = e.flat(1 / 0),
              s = [];
            for (let e = 0, n = t.length; e < n; e++) {
              const n = t[e];
              if (!ee(n)) {
                const e = Ce(n);
                if (e)
                  for (let t = 0, n = e.length; t < n; t++) {
                    const n = e[t];
                    if (!ee(n)) {
                      let e = !1;
                      for (let t = 0, r = s.length; t < r; t++)
                        if (s[t] === n) {
                          e = !0;
                          break;
                        }
                      e || s.push(n);
                    }
                  }
                else {
                  let e = !1;
                  for (let t = 0, r = s.length; t < r; t++)
                    if (s[t] === n) {
                      e = !0;
                      break;
                    }
                  e || s.push(n);
                }
              }
            }
            return s;
          }
          const s = Ce(e);
          return s ? Array.from(s) : [e];
        })(e),
        n = s.length;
      if (n)
        for (let e = 0; e < n; e++) {
          const t = s[e];
          if (!t[y]) {
            t[y] = !0;
            const e = te(t);
            (t.nodeType || e) && ((t[v] = !0), (t[b] = e), (t[T] = {}));
          }
        }
      return s;
    }
    const Le = (e, t, s) => (
        s < 0 && (s += 1),
        s > 1 && (s -= 1),
        s < 1 / 6
          ? e + 6 * (t - e) * s
          : s < 0.5
            ? t
            : s < 2 / 3
              ? e + (t - e) * (2 / 3 - s) * 6
              : e
      ),
      Ee = (e) =>
        ne(e)
          ? ((e) => {
              const t = O.exec(e) || q.exec(e),
                s = K(t[4]) ? 1 : +t[4];
              return [+t[1], +t[2], +t[3], s];
            })(e)
          : se(e)
            ? ((e) => {
                const t = e.length,
                  s = 4 === t || 5 === t;
                return [
                  +("0x" + e[1] + e[s ? 1 : 2]),
                  +("0x" + e[s ? 2 : 3] + e[s ? 2 : 4]),
                  +("0x" + e[s ? 3 : 5] + e[s ? 3 : 6]),
                  5 === t || 9 === t
                    ? +(+("0x" + e[s ? 4 : 7] + e[s ? 4 : 8]) / 255).toFixed(3)
                    : 1,
                ];
              })(e)
            : re(e)
              ? ((e) => {
                  const t = I.exec(e) || M.exec(e),
                    s = +t[1] / 360,
                    n = +t[2] / 100,
                    r = +t[3] / 100,
                    i = K(t[4]) ? 1 : +t[4];
                  let o, a, l;
                  if (0 === n) o = a = l = r;
                  else {
                    const e = r < 0.5 ? r * (1 + n) : r + n - r * n,
                      t = 2 * r - e;
                    ((o = ge(255 * Le(t, e, s + 1 / 3), 0)),
                      (a = ge(255 * Le(t, e, s), 0)),
                      (l = ge(255 * Le(t, e, s - 1 / 3), 0)));
                  }
                  return [o, a, l, i];
                })(e)
              : [0, 0, 0, 1],
      De = (e, t) => (K(e) ? t : e),
      xe = (e, t, s, n, r) => {
        let i;
        if (G(e))
          i = () => {
            const r = e(t, s, n);
            return isNaN(+r) ? r || 0 : +r;
          };
        else {
          if (!W(e) || !Z(e, "var(")) return e;
          i = () => {
            const s = e.match(P),
              n = s[1],
              r = s[2];
            let i = getComputedStyle(t)?.getPropertyValue(n);
            return ((i && i.trim() !== S) || !r || (i = r.trim()), i || 0);
          };
        }
        return (r && (r.func = i), i());
      },
      Ae = (e, t) =>
        e[v]
          ? e[b] &&
            ((e, t) => {
              if (oe.includes(t)) return !1;
              if (e.getAttribute(t) || t in e) {
                if ("scale" === t) {
                  const t = e.parentNode;
                  return t && "filter" === t.tagName;
                }
                return !0;
              }
            })(e, t)
            ? o
            : E.includes(t) || L.get(t)
              ? l
              : Z(t, "--")
                ? c
                : t in e.style
                  ? a
                  : t in e
                    ? i
                    : o
          : i,
      Oe = (e, t, s) => {
        const n = e.style[t];
        n && s && (s[t] = n);
        const r = n || getComputedStyle(e[w] || e).getPropertyValue(t);
        return "auto" === r ? "0" : r;
      },
      qe = (e, t, s, n) => {
        const r = K(s) ? Ae(e, t) : s;
        return r === i
          ? e[t] || 0
          : r === o
            ? e.getAttribute(t)
            : r === l
              ? ((e, t, s) => {
                  const n = e.style.transform;
                  let r;
                  if (n) {
                    const i = e[T];
                    let o;
                    for (; (o = j.exec(n)); ) {
                      const e = o[1],
                        n = o[2].slice(1, -1);
                      ((i[e] = n), e === t && ((r = n), s && (s[t] = n)));
                    }
                  }
                  return n && !K(r)
                    ? r
                    : Z(t, "scale")
                      ? "1"
                      : Z(t, "rotate") || Z(t, "skew")
                        ? "0deg"
                        : "0px";
                })(e, t, n)
              : r === c
                ? Oe(e, t, n).trimStart()
                : Oe(e, t, n);
      },
      Ie = (e, t, s) => ("-" === s ? e - t : "+" === s ? e + t : e * t),
      Me = () => ({ t: u, n: 0, u: null, o: null, d: null, s: null }),
      Re = (e, t) => {
        if (
          ((t.t = u),
          (t.n = 0),
          (t.u = null),
          (t.o = null),
          (t.d = null),
          (t.s = null),
          !e)
        )
          return t;
        const s = +e;
        if (isNaN(s)) {
          let s = e;
          "=" === s[1] && ((t.o = s[0]), (s = s.slice(2)));
          const r = !s.includes(" ") && $.exec(s);
          if (r) return ((t.t = d), (t.n = +r[1]), (t.u = r[2]), t);
          if (t.o) return ((t.n = +s), t);
          if (se((n = s)) || ne(n) || re(n))
            return ((t.t = h), (t.d = Ee(s)), t);
          {
            const e = s.match(R);
            return (
              (t.t = p),
              (t.d = e ? e.map(Number) : []),
              (t.s = s.split(R) || []),
              t
            );
          }
        }
        return ((t.n = s), t);
        var n;
      },
      $e = (e, t) => (
        (t.t = e._valueType),
        (t.n = e._toNumber),
        (t.u = e._unit),
        (t.o = null),
        (t.d = Te(e._toNumbers)),
        (t.s = Te(e._strings)),
        t
      ),
      Be = Me(),
      je = {},
      Pe = (e, t, s) => {
        if (s === l) {
          const t = L.get(e);
          return t || e;
        }
        if (s === a || (s === o && te(t) && e in t.style)) {
          const t = je[e];
          if (t) return t;
          {
            const t = e ? V(e) : e;
            return ((je[e] = t), t);
          }
        }
        return e;
      },
      Ue = (e) => {
        if (e._hasChildren) we(e, Ue, !0);
        else {
          const t = e;
          (t.pause(),
            we(t, (e) => {
              const s = e.property,
                n = e.target;
              if (n[v]) {
                const r = n.style,
                  i = e._inlineValue,
                  o = ee(i) || i === S;
                if (e._tweenType === l) {
                  const t = n[T];
                  if ((o ? delete t[s] : (t[s] = i), e._renderTransforms))
                    if (Object.keys(t).length) {
                      let e = S;
                      for (let s in t) e += D[s] + t[s] + ") ";
                      r.transform = e;
                    } else r.removeProperty("transform");
                } else o ? r.removeProperty(V(s)) : (r[s] = i);
                t._tail === e &&
                  t.targets.forEach((e) => {
                    e.getAttribute &&
                      e.getAttribute("style") === S &&
                      e.removeAttribute("style");
                  });
              }
            }));
        }
        return e;
      },
      ze = { deg: 1, rad: 180 / pe, turn: 360 },
      Xe = {},
      Ye = (e, t, s, n = !1) => {
        const i = t.u,
          o = t.n;
        if (t.t === d && i === s) return t;
        const a = o + i + s,
          l = Xe[a];
        if (K(l) || n) {
          let n;
          if (i in ze) n = (o * ze[i]) / ze[s];
          else {
            const t = 100,
              a = e.cloneNode(),
              l = e.parentNode,
              c = l && l !== r ? l : r.body;
            c.appendChild(a);
            const u = a.style;
            u.width = t + i;
            const d = a.offsetWidth || t;
            u.width = t + s;
            const h = d / (a.offsetWidth || t);
            (c.removeChild(a), (n = h * o));
          }
          ((t.n = n), (Xe[a] = n));
        } else t.n = l;
        return (t.t, (t.u = s), t);
      },
      Ve = (e) => e,
      Ze =
        (e = 1.68) =>
        (t) =>
          ae(t, +e),
      Fe = {
        in: (e) => (t) => e(t),
        out: (e) => (t) => 1 - e(1 - t),
        inOut: (e) => (t) => (t < 0.5 ? e(2 * t) / 2 : 1 - e(-2 * t + 2) / 2),
        outIn: (e) => (t) =>
          t < 0.5 ? (1 - e(1 - 2 * t)) / 2 : (e(2 * t - 1) + 1) / 2,
      },
      He = pe / 2,
      Je = 2 * pe,
      Qe = {
        [S]: Ze,
        Quad: Ze(2),
        Cubic: Ze(3),
        Quart: Ze(4),
        Quint: Ze(5),
        Sine: (e) => 1 - ue(e * He),
        Circ: (e) => 1 - le(1 - e * e),
        Expo: (e) => (e ? ae(2, 10 * e - 10) : 0),
        Bounce: (e) => {
          let t,
            s = 4;
          for (; e < ((t = ae(2, --s)) - 1) / 11; );
          return 1 / ae(4, 3 - s) - 7.5625 * ae((3 * t - 2) / 22 - e, 2);
        },
        Back:
          (e = 1.7) =>
          (t) =>
            (+e + 1) * t * t * t - +e * t * t,
        Elastic: (e = 1, t = 0.3) => {
          const s = _e(+e, 1, 10),
            n = _e(+t, N, 2),
            r = (n / Je) * he(1 / s),
            i = Je / n;
          return (e) =>
            0 === e || 1 === e
              ? e
              : -s * ae(2, -10 * (1 - e)) * ce((1 - e - r) * i);
        },
      },
      We = (() => {
        const e = { linear: Ve, none: Ve };
        for (let t in Fe)
          for (let s in Qe) {
            const n = Qe[s],
              r = Fe[t];
            e[t + s] =
              s === S || "Back" === s || "Elastic" === s
                ? (e, t) => r(n(e, t))
                : r(n);
          }
        return e;
      })(),
      Ge = { linear: Ve, none: Ve },
      Ke = ["steps(", "irregular(", "linear(", "cubicBezier("],
      et = (e) => {
        if (W(e))
          for (let t = 0, s = Ke.length; t < s; t++) if (Z(e, Ke[t])) return Ve;
        return G(e)
          ? e
          : W(e)
            ? ((e) => {
                if (Ge[e]) return Ge[e];
                if (e.indexOf("(") <= -1) {
                  const t =
                    Fe[e] || e.includes("Back") || e.includes("Elastic")
                      ? We[e]()
                      : We[e];
                  return t ? (Ge[e] = t) : Ve;
                }
                {
                  const t = e.slice(0, -1).split("("),
                    s = We[t[0]];
                  return s ? (Ge[e] = s(...t[1].split(","))) : Ve;
                }
              })(e)
            : Ve;
      },
      tt = (e, t, s, n, r) => {
        const m = e.parent,
          y = e.duration,
          v = e.completed,
          b = e.iterationDuration,
          w = e.iterationCount,
          k = e._currentIteration,
          C = e._loopDelay,
          L = e._reversed,
          E = e._alternate,
          x = e._hasChildren,
          A = e._delay,
          O = e._currentTime,
          q = A + b,
          I = t - A,
          M = _e(O, -A, y),
          R = _e(I, -A, y),
          $ = I - O,
          B = R > 0,
          j = R >= y,
          P = y <= N,
          U = r === f;
        let z = 0,
          Y = I,
          V = 0;
        if (w > 1) {
          const t = ~~(R / (b + (j ? 0 : C)));
          ((e._currentIteration = _e(t, 0, w)),
            j && e._currentIteration--,
            (z = e._currentIteration % 2),
            (Y = R % (b + C) || 0));
        }
        const Z = L ^ (E && z),
          F = e._ease;
        let H = j ? (Z ? 0 : y) : Z ? b - Y : Y;
        F && (H = b * F(H / b) || 0);
        const J = (m ? m.backwards : I < O) ? !Z : !!Z;
        if (
          ((e._currentTime = I),
          (e._iterationTime = H),
          (e.backwards = J),
          B && !e.began
            ? ((e.began = !0), s || (m && (J || !m.began)) || e.onBegin(e))
            : I <= 0 && (e.began = !1),
          s || x || !B || e._currentIteration === k || e.onLoop(e),
          U ||
            (r === _ &&
              ((t >= A && t <= q) ||
                (t <= A && M > A) ||
                (t >= q && M !== y))) ||
            (H >= q && M !== y) ||
            (H <= A && M > 0) ||
            (t <= M && M === y && v) ||
            (j && !v && P))
        ) {
          if ((B && (e.computeDeltaTime(M), s || e.onBeforeUpdate(e)), !x)) {
            const t = U || (J ? -1 * $ : $) >= X.tickThreshold,
              r = e._offset + (m ? m._offset : 0) + A + H;
            let _,
              f,
              y,
              v,
              b = e._head,
              w = 0;
            for (; b; ) {
              const e = b._composition,
                s = b._currentTime,
                m = b._changeDuration,
                N = b._absoluteStartTime + b._changeDuration,
                k = b._nextRep,
                C = b._prevRep,
                L = e !== g.none;
              if (
                (t ||
                  ((s !== m || r <= N + (k ? k._delay : 0)) &&
                    (0 !== s || r >= b._absoluteStartTime))) &&
                (!L ||
                  (!b._isOverridden &&
                    (!b._isOverlapped || r <= N) &&
                    (!k || k._isOverridden || r <= k._absoluteStartTime) &&
                    (!C ||
                      C._isOverridden ||
                      r >=
                        C._absoluteStartTime + C._changeDuration + b._delay)))
              ) {
                const t = (b._currentTime = _e(H - b._startTime, 0, m)),
                  s = b._ease(t / b._updateDuration),
                  r = b._modifier,
                  N = b._valueType,
                  k = b._tweenType,
                  C = k === i,
                  S = N === u,
                  E = (S && C) || 0 === s || 1 === s ? -1 : X.precision;
                let D, x;
                if (S) D = x = r(ge(ye(b._fromNumber, b._toNumber, s), E));
                else if (N === d)
                  ((x = r(ge(ye(b._fromNumber, b._toNumber, s), E))),
                    (D = `${x}${b._unit}`));
                else if (N === h) {
                  const e = b._fromNumbers,
                    t = b._toNumbers,
                    n = ge(_e(r(ye(e[0], t[0], s)), 0, 255), 0),
                    i = ge(_e(r(ye(e[1], t[1], s)), 0, 255), 0),
                    o = ge(_e(r(ye(e[2], t[2], s)), 0, 255), 0),
                    a = _e(r(ge(ye(e[3], t[3], s), E)), 0, 1);
                  if (((D = `rgba(${n},${i},${o},${a})`), L)) {
                    const e = b._numbers;
                    ((e[0] = n), (e[1] = i), (e[2] = o), (e[3] = a));
                  }
                } else if (N === p) {
                  D = b._strings[0];
                  for (let e = 0, t = b._toNumbers.length; e < t; e++) {
                    const t = r(
                        ge(ye(b._fromNumbers[e], b._toNumbers[e], s), E),
                      ),
                      n = b._strings[e + 1];
                    ((D += `${n ? t + n : t}`), L && (b._numbers[e] = t));
                  }
                }
                if ((L && (b._number = x), n || e === g.blend)) b._value = D;
                else {
                  const e = b.property;
                  ((_ = b.target),
                    C
                      ? (_[e] = D)
                      : k === o
                        ? _.setAttribute(e, D)
                        : ((f = _.style),
                          k === l
                            ? (_ !== y && ((y = _), (v = _[T])),
                              (v[e] = D),
                              (w = 1))
                            : k === a
                              ? (f[e] = D)
                              : k === c && f.setProperty(e, D)),
                    B && (V = 1));
                }
              }
              if (w && b._renderTransforms) {
                let e = S;
                for (let t in v) e += `${D[t]}${v[t]}) `;
                ((f.transform = e), (w = 0));
              }
              b = b._next;
            }
            !s && V && e.onRender(e);
          }
          !s && B && e.onUpdate(e);
        }
        return (
          m && P
            ? !s &&
              ((m.began && !J && I > 0 && !v) || (J && I <= N && v)) &&
              (e.onComplete(e), (e.completed = !J))
            : B && j
              ? w === 1 / 0
                ? (e._startTime += e.duration)
                : e._currentIteration >= w - 1 &&
                  ((e.paused = !0),
                  v ||
                    x ||
                    ((e.completed = !0),
                    s ||
                      (m && (J || !m.began)) ||
                      (e.onComplete(e), e._resolve(e))))
              : (e.completed = !1),
          V
        );
      },
      st = (e, t, s, n, r) => {
        const i = e._currentIteration;
        if ((tt(e, t, s, n, r), e._hasChildren)) {
          const o = e,
            a = o.backwards,
            l = n ? t : o._iterationTime,
            c = F();
          let u = 0,
            d = !0;
          if (!n && o._currentIteration !== i) {
            const e = o.iterationDuration;
            (we(o, (t) => {
              if (a) {
                const n = t.duration,
                  r = t._offset + t._delay;
                s || !(n <= N) || (r && r + n !== e) || t.onComplete(t);
              } else
                (!t.completed &&
                  !t.backwards &&
                  t._currentTime < t.iterationDuration &&
                  tt(t, e, s, 1, f),
                  (t.began = !1),
                  (t.completed = !1));
            }),
              s || o.onLoop(o));
          }
          (we(
            o,
            (e) => {
              const t = ge((l - e._offset) * e._speed, 12),
                i = e._fps < o._fps ? e.requestTick(c) : r;
              ((u += tt(e, t, s, n, i)), !e.completed && d && (d = !1));
            },
            a,
          ),
            !s && u && o.onRender(o),
            (d || a) &&
              o._currentTime >= o.duration &&
              ((o.paused = !0),
              o.completed ||
                ((o.completed = !0), s || (o.onComplete(o), o._resolve(o)))));
        }
      },
      nt = { animation: null, update: x },
      rt = { _rep: new WeakMap(), _add: new Map() },
      it = (e, t, s = "_rep") => {
        const n = rt[s];
        let r = n.get(e);
        return (
          r || ((r = {}), n.set(e, r)),
          r[t] ? r[t] : (r[t] = { _head: null, _tail: null })
        );
      },
      ot = (e, t) =>
        e._isOverridden || e._absoluteStartTime > t._absoluteStartTime,
      at = (e) => {
        ((e._isOverlapped = 1),
          (e._isOverridden = 1),
          (e._changeDuration = N),
          (e._currentTime = N));
      },
      lt = (e, t) => {
        const s = e._composition;
        if (s === g.replace) {
          const s = e._absoluteStartTime;
          ke(t, e, ot, "_prevRep", "_nextRep");
          const n = e._prevRep;
          if (n) {
            const t = n.parent,
              r = n._absoluteStartTime + n._changeDuration;
            if (
              e.parent.id !== t.id &&
              t.iterationCount > 1 &&
              r + (t.duration - t.iterationDuration) > s
            ) {
              at(n);
              let e = n._prevRep;
              for (; e && e.parent.id === t.id; ) (at(e), (e = e._prevRep));
            }
            const i = s - e._delay;
            if (r > i) {
              const e = n._startTime,
                t = r - (e + n._updateDuration),
                s = ge(i - t - e, 12);
              ((n._changeDuration = s),
                (n._currentTime = s),
                (n._isOverlapped = 1),
                s < N && at(n));
            }
            let o = !0;
            if (
              (we(t, (e) => {
                e._isOverlapped || (o = !1);
              }),
              o)
            ) {
              const e = t.parent;
              if (e) {
                let s = !0;
                (we(e, (e) => {
                  e !== t &&
                    we(e, (e) => {
                      e._isOverlapped || (s = !1);
                    });
                }),
                  s && e.cancel());
              } else t.cancel();
            }
          }
        } else if (s === g.blend) {
          const t = it(e.target, e.property, "_add"),
            s = ((e) => {
              let t = nt.animation;
              return (
                t ||
                  ((t = {
                    duration: N,
                    computeDeltaTime: x,
                    _offset: 0,
                    _delay: 0,
                    _head: null,
                    _tail: null,
                  }),
                  (nt.animation = t),
                  (nt.update = () => {
                    (e.forEach((e) => {
                      for (let t in e) {
                        const s = e[t],
                          n = s._head;
                        if (n) {
                          const e = n._valueType,
                            t = e === p || e === h ? Te(n._fromNumbers) : null;
                          let r = n._fromNumber,
                            i = s._tail;
                          for (; i && i !== n; ) {
                            if (t)
                              for (let e = 0, s = i._numbers.length; e < s; e++)
                                t[e] += i._numbers[e];
                            else r += i._number;
                            i = i._prevAdd;
                          }
                          ((n._toNumber = r), (n._toNumbers = t));
                        }
                      }
                    }),
                      tt(t, 1, 1, 0, f));
                  })),
                t
              );
            })(rt._add);
          let n = t._head;
          n ||
            ((n = { ...e }),
            (n._composition = g.replace),
            (n._updateDuration = N),
            (n._startTime = 0),
            (n._numbers = Te(e._fromNumbers)),
            (n._number = 0),
            (n._next = null),
            (n._prev = null),
            ke(t, n),
            ke(s, n));
          const r = e._toNumber;
          if (
            ((e._fromNumber = n._fromNumber - r),
            (e._toNumber = 0),
            (e._numbers = Te(e._fromNumbers)),
            (e._number = 0),
            (n._fromNumber = r),
            e._toNumbers)
          ) {
            const t = Te(e._toNumbers);
            (t &&
              t.forEach((t, s) => {
                ((e._fromNumbers[s] = n._fromNumbers[s] - t),
                  (e._toNumbers[s] = 0));
              }),
              (n._fromNumbers = t));
          }
          ke(t, e, null, "_prevAdd", "_nextAdd");
        }
        return e;
      },
      ct = (e) => {
        const t = e._composition;
        if (t !== g.none) {
          const s = e.target,
            n = e.property,
            r = rt._rep.get(s)[n];
          if ((Ne(r, e, "_prevRep", "_nextRep"), t === g.blend)) {
            const t = rt._add,
              r = t.get(s);
            if (!r) return;
            const i = r[n],
              o = nt.animation;
            Ne(i, e, "_prevAdd", "_nextAdd");
            const a = i._head;
            if (a && a === i._tail) {
              (Ne(i, a, "_prevAdd", "_nextAdd"), Ne(o, a));
              let e = !0;
              for (let t in r)
                if (r[t]._head) {
                  e = !1;
                  break;
                }
              e && t.delete(s);
            }
          }
        }
        return e;
      };
    class ut {
      constructor(e = 0) {
        ((this.deltaTime = 0),
          (this._currentTime = e),
          (this._elapsedTime = e),
          (this._startTime = e),
          (this._lastTime = e),
          (this._scheduledTime = 0),
          (this._frameDuration = ge(C / 120, 0)),
          (this._fps = 120),
          (this._speed = 1),
          (this._hasChildren = !1),
          (this._head = null),
          (this._tail = null));
      }
      get fps() {
        return this._fps;
      }
      set fps(e) {
        const t = this._frameDuration,
          s = +e,
          n = s < N ? N : s,
          r = ge(C / n, 0);
        ((this._fps = n),
          (this._frameDuration = r),
          (this._scheduledTime += r - t));
      }
      get speed() {
        return this._speed;
      }
      set speed(e) {
        const t = +e;
        this._speed = t < N ? N : t;
      }
      requestTick(e) {
        const t = this._scheduledTime,
          s = this._elapsedTime;
        if (((this._elapsedTime += e - s), s < t)) return m;
        const n = this._frameDuration,
          r = s - t;
        return ((this._scheduledTime += r < n ? n : r), _);
      }
      computeDeltaTime(e) {
        const t = e - this._lastTime;
        return ((this.deltaTime = t), (this._lastTime = e), t);
      }
    }
    const dt = (() => (t ? requestAnimationFrame : setImmediate))(),
      ht = (() => (t ? cancelAnimationFrame : clearImmediate))();
    class pt extends ut {
      constructor(e) {
        (super(e),
          (this.useDefaultMainLoop = !0),
          (this.pauseOnDocumentHidden = !0),
          (this.defaults = U),
          (this.paused = !0),
          (this.reqId = 0));
      }
      update() {
        const e = (this._currentTime = F());
        if (this.requestTick(e)) {
          this.computeDeltaTime(e);
          const t = this._speed,
            s = this._fps;
          let n = this._head;
          for (; n; ) {
            const r = n._next;
            (n.paused
              ? (Ne(this, n),
                (this._hasChildren = !!this._tail),
                (n._running = !1),
                n.completed && !n._cancelled && n.cancel())
              : st(
                  n,
                  (e - n._startTime) * n._speed * t,
                  0,
                  0,
                  n._fps < s ? n.requestTick(e) : _,
                ),
              (n = r));
          }
          nt.update();
        }
      }
      wake() {
        return (
          this.useDefaultMainLoop &&
            !this.reqId &&
            (this.requestTick(F()), (this.reqId = dt(_t))),
          this
        );
      }
      pause() {
        if (this.reqId) return ((this.paused = !0), ft());
      }
      resume() {
        if (this.paused)
          return (
            (this.paused = !1),
            we(this, (e) => e.resetTime()),
            this.wake()
          );
      }
      get speed() {
        return this._speed * (1 === X.timeScale ? 1 : C);
      }
      set speed(e) {
        ((this._speed = e * X.timeScale),
          we(this, (e) => (e.speed = e._speed)));
      }
      get timeUnit() {
        return 1 === X.timeScale ? "ms" : "s";
      }
      set timeUnit(e) {
        const t = "s" === e,
          s = t ? 0.001 : 1;
        if (X.timeScale !== s) {
          ((X.timeScale = s), (X.tickThreshold = 200 * s));
          const e = t ? 0.001 : C;
          ((this.defaults.duration *= e), (this._speed *= e));
        }
      }
      get precision() {
        return X.precision;
      }
      set precision(e) {
        X.precision = e;
      }
    }
    const mt = (() => {
        const e = new pt(F());
        return (
          t &&
            ((Y.engine = e),
            r.addEventListener("visibilitychange", () => {
              e.pauseOnDocumentHidden && (r.hidden ? e.pause() : e.resume());
            })),
          e
        );
      })(),
      _t = () => {
        mt._head ? ((mt.reqId = dt(_t)), mt.update()) : (mt.reqId = 0);
      },
      ft = () => (ht(mt.reqId), (mt.reqId = 0), mt),
      gt = (e) => ((e.paused = !0), (e.began = !1), (e.completed = !1), e),
      yt = (e) =>
        e._cancelled
          ? (e._hasChildren
              ? we(e, yt)
              : we(e, (e) => {
                  e._composition !== g.none && lt(e, it(e.target, e.property));
                }),
            (e._cancelled = 0),
            e)
          : e;
    let vt = 0;
    class bt extends ut {
      constructor(e = {}, t = null, s = 0) {
        super(0);
        const {
          id: n,
          delay: r,
          duration: i,
          reversed: o,
          alternate: a,
          loop: l,
          loopDelay: c,
          autoplay: u,
          frameRate: d,
          playbackRate: h,
          onComplete: p,
          onLoop: m,
          onPause: _,
          onBegin: f,
          onBeforeUpdate: g,
          onUpdate: y,
        } = e;
        z.current && z.current.register(this);
        const v = t ? 0 : mt._elapsedTime,
          b = t ? t.defaults : X.defaults,
          T = G(r) || K(r) ? b.delay : +r,
          w = G(i) || K(i) ? 1 / 0 : +i,
          k = De(l, b.loop),
          C = De(c, b.loopDelay),
          S = !0 === k || k === 1 / 0 || k < 0 ? 1 / 0 : k + 1;
        let L = 0;
        (t
          ? (L = s)
          : (mt.reqId || mt.requestTick(F()),
            (L = (mt._elapsedTime - mt._startTime) * X.timeScale)),
          (this.id = K(n) ? ++vt : n),
          (this.parent = t),
          (this.duration = ve((w + C) * S - C) || N),
          (this.backwards = !1),
          (this.paused = !0),
          (this.began = !1),
          (this.completed = !1),
          (this.onBegin = f || b.onBegin),
          (this.onBeforeUpdate = g || b.onBeforeUpdate),
          (this.onUpdate = y || b.onUpdate),
          (this.onLoop = m || b.onLoop),
          (this.onPause = _ || b.onPause),
          (this.onComplete = p || b.onComplete),
          (this.iterationDuration = w),
          (this.iterationCount = S),
          (this._autoplay = !t && De(u, b.autoplay)),
          (this._offset = L),
          (this._delay = T),
          (this._loopDelay = C),
          (this._iterationTime = 0),
          (this._currentIteration = 0),
          (this._resolve = x),
          (this._running = !1),
          (this._reversed = +De(o, b.reversed)),
          (this._reverse = this._reversed),
          (this._cancelled = 0),
          (this._alternate = De(a, b.alternate)),
          (this._prev = null),
          (this._next = null),
          (this._elapsedTime = v),
          (this._startTime = v),
          (this._lastTime = v),
          (this._fps = De(d, b.frameRate)),
          (this._speed = De(h, b.playbackRate)));
      }
      get cancelled() {
        return !!this._cancelled;
      }
      set cancelled(e) {
        e ? this.cancel() : this.reset(!0).play();
      }
      get currentTime() {
        return _e(
          ge(this._currentTime, X.precision),
          -this._delay,
          this.duration,
        );
      }
      set currentTime(e) {
        const t = this.paused;
        (this.pause().seek(+e), t || this.resume());
      }
      get iterationCurrentTime() {
        return ge(this._iterationTime, X.precision);
      }
      set iterationCurrentTime(e) {
        this.currentTime = this.iterationDuration * this._currentIteration + e;
      }
      get progress() {
        return _e(ge(this._currentTime / this.duration, 10), 0, 1);
      }
      set progress(e) {
        this.currentTime = this.duration * e;
      }
      get iterationProgress() {
        return _e(ge(this._iterationTime / this.iterationDuration, 10), 0, 1);
      }
      set iterationProgress(e) {
        const t = this.iterationDuration;
        this.currentTime = t * this._currentIteration + t * e;
      }
      get currentIteration() {
        return this._currentIteration;
      }
      set currentIteration(e) {
        this.currentTime =
          this.iterationDuration * _e(+e, 0, this.iterationCount - 1);
      }
      get reversed() {
        return !!this._reversed;
      }
      set reversed(e) {
        e ? this.reverse() : this.play();
      }
      get speed() {
        return super.speed;
      }
      set speed(e) {
        ((super.speed = e), this.resetTime());
      }
      reset(e = !1) {
        return (
          yt(this),
          this._reversed && !this._reverse && (this.reversed = !1),
          (this._iterationTime = this.iterationDuration),
          st(this, 0, 1, ~~e, f),
          gt(this),
          this._hasChildren && we(this, gt),
          this
        );
      }
      init(e = !1) {
        ((this.fps = this._fps),
          (this.speed = this._speed),
          !e && this._hasChildren && st(this, this.duration, 1, ~~e, f),
          this.reset(e));
        const t = this._autoplay;
        return (
          !0 === t ? this.resume() : t && !K(t.linked) && t.link(this),
          this
        );
      }
      resetTime() {
        const e = 1 / (this._speed * mt._speed);
        return (
          (this._startTime = F() - (this._currentTime + this._delay) * e),
          this
        );
      }
      pause() {
        return (this.paused || ((this.paused = !0), this.onPause(this)), this);
      }
      resume() {
        return this.paused
          ? ((this.paused = !1),
            this.duration <= N && !this._hasChildren
              ? st(this, N, 0, 0, f)
              : (this._running ||
                  (ke(mt, this), (mt._hasChildren = !0), (this._running = !0)),
                this.resetTime(),
                (this._startTime -= 12),
                mt.wake()),
            this)
          : this;
      }
      restart() {
        return this.reset().resume();
      }
      seek(e, t = 0, s = 0) {
        (yt(this), (this.completed = !1));
        const n = this.paused;
        return (
          (this.paused = !0),
          st(this, e + this._delay, ~~t, ~~s, _),
          n ? this : this.resume()
        );
      }
      alternate() {
        const e = this._reversed,
          t = this.iterationCount,
          s = this.iterationDuration,
          n = t === 1 / 0 ? de(k / s) : t;
        return (
          (this._reversed = +(!this._alternate || n % 2 ? !e : e)),
          t === 1 / 0
            ? (this.iterationProgress = this._reversed
                ? 1 - this.iterationProgress
                : this.iterationProgress)
            : this.seek(s * n - this._currentTime),
          this.resetTime(),
          this
        );
      }
      play() {
        return (this._reversed && this.alternate(), this.resume());
      }
      reverse() {
        return (this._reversed || this.alternate(), this.resume());
      }
      cancel() {
        return (
          this._hasChildren ? we(this, (e) => e.cancel(), !0) : we(this, ct),
          (this._cancelled = 1),
          this.pause()
        );
      }
      stretch(e) {
        const t = this.duration,
          s = be(e);
        if (t === s) return this;
        const n = e / t,
          r = e <= N;
        return (
          (this.duration = r ? N : s),
          (this.iterationDuration = r ? N : be(this.iterationDuration * n)),
          (this._offset *= n),
          (this._delay *= n),
          (this._loopDelay *= n),
          this
        );
      }
      revert() {
        st(this, 0, 1, 0, _);
        const e = this._autoplay;
        return (
          e && e.linked && e.linked === this && e.revert(),
          this.cancel()
        );
      }
      complete() {
        return this.seek(this.duration).cancel();
      }
      then(e = x) {
        const t = this.then,
          s = () => {
            ((this.then = null), e(this), (this.then = t), (this._resolve = x));
          };
        return new Promise(
          (e) => (
            (this._resolve = () => e(s())),
            this.completed && this._resolve(),
            this
          ),
        );
      }
    }
    const Tt = Me(),
      wt = Me(),
      Nt = {},
      kt = { func: null },
      Ct = [null],
      St = [null, null],
      Lt = { to: null };
    let Et,
      Dt,
      xt = 0;
    class At extends bt {
      constructor(e, t, s, n, r = !1, i = 0, o = 0) {
        super(t, s, n);
        const a = Se(e),
          c = a.length,
          m = t.keyframes,
          _ = m
            ? ((e, t) => {
                const s = { ...e };
                for (let n in t) {
                  const r = e[n];
                  s[n] = K(r) ? t[n] : r;
                }
                return s;
              })(
                ((e, t) => {
                  const s = {};
                  if (H(e)) {
                    const t = []
                      .concat(...e.map((e) => Object.keys(e)))
                      .filter(ie);
                    for (let n = 0, r = t.length; n < r; n++) {
                      const r = t[n],
                        i = e.map((e) => {
                          const t = {};
                          for (let s in e) {
                            const n = e[s];
                            ie(s) ? s === r && (t.to = n) : (t[s] = n);
                          }
                          return t;
                        });
                      s[r] = i;
                    }
                  } else {
                    const n = De(t.duration, X.defaults.duration),
                      r = Object.keys(e)
                        .map((t) => ({ o: parseFloat(t) / 100, p: e[t] }))
                        .sort((e, t) => e.o - t.o);
                    r.forEach((e) => {
                      const t = e.o,
                        r = e.p;
                      for (let e in r)
                        if (ie(e)) {
                          let i = s[e];
                          i || (i = s[e] = []);
                          const o = t * n;
                          let a = i.length,
                            l = i[a - 1];
                          const c = { to: r[e] };
                          let u = 0;
                          for (let e = 0; e < a; e++) u += i[e].duration;
                          (1 === a && (c.from = l.to),
                            r.ease && (c.ease = r.ease),
                            (c.duration = o - (a ? u : 0)),
                            i.push(c));
                        }
                      return e;
                    });
                    for (let e in s) {
                      const t = s[e];
                      let n;
                      for (let e = 0, s = t.length; e < s; e++) {
                        const s = t[e],
                          r = s.ease;
                        ((s.ease = n || void 0), (n = r));
                      }
                      t[0].duration || t.shift();
                    }
                  }
                  return s;
                })(m, t),
                t,
              )
            : t,
          {
            delay: f,
            duration: y,
            ease: v,
            playbackEase: b,
            modifier: T,
            composition: w,
            onRender: k,
          } = _,
          S = s ? s.defaults : X.defaults,
          L = De(b, S.playbackEase),
          E = L ? et(L) : null,
          D = !K(v) && !K(v.ease),
          x = D ? v.ease : De(v, E ? "linear" : S.ease),
          A = D ? v.settlingDuration : De(y, S.duration),
          O = De(f, S.delay),
          q = T || S.modifier,
          I = K(w) && c >= C ? g.none : K(w) ? S.composition : w,
          M = this._offset + (s ? s._offset : 0);
        D && (v.parent = this);
        let R = NaN,
          $ = NaN,
          B = 0,
          j = 0;
        for (let e = 0; e < c; e++) {
          const t = a[e],
            n = i || e,
            m = o || c;
          let f = NaN,
            y = NaN;
          for (let e in _)
            if (ie(e)) {
              const i = Ae(t, e),
                o = Pe(e, t, i);
              let a = _[e];
              const c = H(a);
              if ((r && !c && ((St[0] = a), (St[1] = a), (a = St)), c)) {
                const e = a.length,
                  t = !J(a[0]);
                2 === e && t
                  ? ((Lt.to = a), (Ct[0] = Lt), (Et = Ct))
                  : e > 2 && t
                    ? ((Et = []),
                      a.forEach((e, t) => {
                        t
                          ? 1 === t
                            ? ((St[1] = e), Et.push(St))
                            : Et.push(e)
                          : (St[0] = e);
                      }))
                    : (Et = a);
              } else ((Ct[0] = a), (Et = Ct));
              let v = null,
                b = null,
                T = NaN,
                w = 0,
                k = 0;
              for (let e = Et.length; k < e; k++) {
                const r = Et[k];
                (J(r) ? (Dt = r) : ((Lt.to = r), (Dt = Lt)), (kt.func = null));
                const a = xe(Dt.to, t, n, m, kt);
                let l;
                J(a) && !K(a.to) ? ((Dt = a), (l = a.to)) : (l = a);
                const c = xe(Dt.from, t, n, m),
                  _ = Dt.ease,
                  f = !K(_) && !K(_.ease),
                  y = f ? _.ease : _ || x,
                  C = f
                    ? _.settlingDuration
                    : xe(
                        De(Dt.duration, e > 1 ? xe(A, t, n, m) / e : A),
                        t,
                        n,
                        m,
                      ),
                  S = xe(De(Dt.delay, k ? 0 : O), t, n, m),
                  L = xe(De(Dt.composition, I), t, n, m),
                  E = Q(L) ? L : g[L],
                  D = Dt.modifier || q,
                  R = !K(c),
                  $ = !K(l),
                  P = H(l),
                  U = P || (R && $),
                  z = b ? w + S : S,
                  X = ge(M + z, 12);
                j || (!R && !P) || (j = 1);
                let Y = b;
                if (E !== g.none) {
                  v || (v = it(t, o));
                  let e = v._head;
                  for (; e && !e._isOverridden && e._absoluteStartTime <= X; )
                    if (
                      ((Y = e),
                      (e = e._nextRep),
                      e && e._absoluteStartTime >= X)
                    )
                      for (; e; ) (at(e), (e = e._nextRep));
                }
                if (
                  (U
                    ? (Re(P ? xe(l[0], t, n, m) : c, Tt),
                      Re(P ? xe(l[1], t, n, m, kt) : l, wt),
                      Tt.t === u &&
                        (Y
                          ? Y._valueType === d && ((Tt.t = d), (Tt.u = Y._unit))
                          : (Re(qe(t, o, i, Nt), Be),
                            Be.t === d && ((Tt.t = d), (Tt.u = Be.u)))))
                    : ($
                        ? Re(l, wt)
                        : b
                          ? $e(b, wt)
                          : Re(
                              s && Y && Y.parent.parent === s
                                ? Y._value
                                : qe(t, o, i, Nt),
                              wt,
                            ),
                      R
                        ? Re(c, Tt)
                        : b
                          ? $e(b, Tt)
                          : Re(
                              s && Y && Y.parent.parent === s
                                ? Y._value
                                : qe(t, o, i, Nt),
                              Tt,
                            )),
                  Tt.o &&
                    (Tt.n = Ie(
                      Y ? Y._toNumber : Re(qe(t, o, i, Nt), Be).n,
                      Tt.n,
                      Tt.o,
                    )),
                  wt.o && (wt.n = Ie(Tt.n, wt.n, wt.o)),
                  Tt.t !== wt.t)
                )
                  if (Tt.t === p || wt.t === p) {
                    const e = Tt.t === p ? Tt : wt,
                      t = Tt.t === p ? wt : Tt;
                    ((t.t = p), (t.s = Te(e.s)), (t.d = e.d.map(() => t.n)));
                  } else if (Tt.t === d || wt.t === d) {
                    const e = Tt.t === d ? Tt : wt,
                      t = Tt.t === d ? wt : Tt;
                    ((t.t = d), (t.u = e.u));
                  } else if (Tt.t === h || wt.t === h) {
                    const e = Tt.t === h ? Tt : wt,
                      t = Tt.t === h ? wt : Tt;
                    ((t.t = h), (t.s = e.s), (t.d = [0, 0, 0, 1]));
                  }
                if (Tt.u !== wt.u) {
                  let e = wt.u ? Tt : wt;
                  e = Ye(t, e, wt.u ? wt.u : Tt.u, !1);
                }
                if (wt.d && Tt.d && wt.d.length !== Tt.d.length) {
                  const e = Tt.d.length > wt.d.length ? Tt : wt,
                    t = e === Tt ? wt : Tt;
                  ((t.d = e.d.map((e, s) => (K(t.d[s]) ? 0 : t.d[s]))),
                    (t.s = Te(e.s)));
                }
                const V = ge(+C || N, 12);
                let Z = Nt[o];
                ee(Z) || (Nt[o] = null);
                const F = {
                  parent: this,
                  id: xt++,
                  property: o,
                  target: t,
                  _value: null,
                  _func: kt.func,
                  _ease: et(y),
                  _fromNumbers: Te(Tt.d),
                  _toNumbers: Te(wt.d),
                  _strings: Te(wt.s),
                  _fromNumber: Tt.n,
                  _toNumber: wt.n,
                  _numbers: Te(Tt.d),
                  _number: Tt.n,
                  _unit: wt.u,
                  _modifier: D,
                  _currentTime: 0,
                  _startTime: z,
                  _delay: +S,
                  _updateDuration: V,
                  _changeDuration: V,
                  _absoluteStartTime: X,
                  _tweenType: i,
                  _valueType: wt.t,
                  _composition: E,
                  _isOverlapped: 0,
                  _isOverridden: 0,
                  _renderTransforms: 0,
                  _inlineValue: Z,
                  _prevRep: null,
                  _nextRep: null,
                  _prevAdd: null,
                  _nextAdd: null,
                  _prev: null,
                  _next: null,
                };
                (E !== g.none && lt(F, v),
                  isNaN(T) && (T = F._startTime),
                  (w = ge(z + V, 12)),
                  (b = F),
                  B++,
                  ke(this, F));
              }
              ((isNaN($) || T < $) && ($ = T),
                (isNaN(R) || w > R) && (R = w),
                i === l && ((f = B - k), (y = B)));
            }
          if (!isNaN(f)) {
            let e = 0;
            we(this, (t) => {
              (e >= f &&
                e < y &&
                ((t._renderTransforms = 1),
                t._composition === g.blend &&
                  we(nt.animation, (e) => {
                    e.id === t.id && (e._renderTransforms = 1);
                  })),
                e++);
            });
          }
        }
        ($
          ? (we(this, (e) => {
              (e._startTime - e._delay || (e._delay -= $), (e._startTime -= $));
            }),
            (R -= $))
          : ($ = 0),
          R || ((R = N), (this.iterationCount = 0)),
          (this.targets = a),
          (this.duration =
            R === N
              ? N
              : ve(
                  (R + this._loopDelay) * this.iterationCount - this._loopDelay,
                ) || N),
          (this.onRender = k || S.onRender),
          (this._ease = E),
          (this._delay = $),
          (this.iterationDuration = R),
          !this._autoplay && j && this.onRender(this));
      }
      stretch(e) {
        const t = this.duration;
        if (t === be(e)) return this;
        const s = e / t;
        return (
          we(this, (e) => {
            ((e._updateDuration = be(e._updateDuration * s)),
              (e._changeDuration = be(e._changeDuration * s)),
              (e._currentTime *= s),
              (e._startTime *= s),
              (e._absoluteStartTime *= s));
          }),
          super.stretch(e)
        );
      }
      refresh() {
        return (
          we(this, (e) => {
            const t = e._func;
            if (t) {
              const s = qe(e.target, e.property, e._tweenType);
              (Re(s, Be),
                Re(t(), wt),
                (e._fromNumbers = Te(Be.d)),
                (e._fromNumber = Be.n),
                (e._toNumbers = Te(wt.d)),
                (e._strings = Te(wt.s)),
                (e._toNumber = wt.o ? Ie(Be.n, wt.n, wt.o) : wt.n));
            }
          }),
          this.duration === N && this.restart(),
          this
        );
      }
      revert() {
        return (super.revert(), Ue(this));
      }
      then(e) {
        return super.then(e);
      }
    }
    const Ot = (e, t) => new At(e, t, null, 0, !1).init(),
      qt = (e, t = { root: ".wrapper" }) => {
        const s = window.navigator.userAgent.toLowerCase(),
          n =
            s.indexOf("iphone") > -1 ||
            s.indexOf("ipad") > -1 ||
            (s.indexOf("macintosh") > -1 && "ontouchend" in document),
          r = "is-scrolllock",
          i = document.getElementsByTagName("html")[0],
          o =
            "string" == typeof t.root ? document.querySelector(t.root) : t.root;
        e
          ? (i.classList.add(r),
            n
              ? (o && (o.bslock = window.pageYOffset),
                o && (o.style.position = "fixed"),
                o && (o.style.top = -1 * o.bslock + "px"))
              : o && (o.style.overflow = "hidden"))
          : (i.classList.remove(r),
            n
              ? (o && (o.style.position = ""),
                o && (o.style.top = ""),
                window.scrollTo(0, o.bslock),
                o && (o.bslock = 0))
              : o && (o.style.overflow = ""));
      },
      It = (e) => {
        e.preventDefault();
        const cjBtn = e.currentTarget;
        if (cjBtn.dataset.cjDrawerLock) return;
        cjBtn.dataset.cjDrawerLock = "1";
        setTimeout(function () {
          delete cjBtn.dataset.cjDrawerLock;
        }, 500);
        const t = "active",
          s = cjBtn.dataset.rel,
          h = cjBtn.closest(".cj-header-bar"),
          b = h || document,
          n = b.querySelector(`[data-js*="drawer-cts"][data-rel*="${s}"]`),
          r = n && n.classList.contains(t),
          i = b.querySelectorAll(
            `[data-js*="drawer-toggle"][data-rel*="${s}"], [data-js*="drawer-cts"][data-rel*="${s}"]`,
          );
        for (let e = 0, s = i.length; e < s; e++) {
          const s = i[e];
          r ? s.classList.remove(t) : s.classList.add(t);
        }
        const o = { duration: 150, ease: "outCubic" };
        r
          ? (document.body.classList.remove("is-menu"),
            Ot(
              n,
              Object.assign({ delay: 150 }, o, {
                opacity: 0,
                onBegin: (e) => {
                  (e.targets[0].classList.add("close-start"),
                    e.targets[0].classList.remove("open-done"),
                    qt(!1));
                },
                onComplete: (e) => {
                  (e.targets[0].classList.remove("close-start"),
                    (e.targets[0].style.display = ""),
                    (e.targets[0].style.opacity = ""));
                },
              }),
            ))
          : (document.body.classList.add("is-menu"),
            Ot(
              n,
              Object.assign({}, o, {
                opacity: 1,
                onBegin: (e) => {
                  e.targets[0].style.display = "block";
                },
                onComplete: (e) => {
                  (e.targets[0].classList.add("open-done"),
                    (e.targets[0].style.display = ""),
                    (e.targets[0].style.opacity = ""),
                    qt(!0));
                },
              }),
            ));
      },
      Mt = (e) => {
        e.preventDefault();
        const t = e.currentTarget.dataset.drawerClose;
        if (!t) return;
        const h = e.currentTarget.closest(".cj-header-bar"),
          b = h || document,
          s = b.querySelector(`[data-js*="drawer-toggle"][data-rel*="${t}"]`);
        s && s.click();
      },
      Rt = (e) => {
        if (e.closest("[hidden]") || e.dataset.cjDrawerBound) return;
        e.dataset.cjDrawerBound = "1";
        e.addEventListener("click", It, !1);
      },
      $t = (e = '[data-js*="drawer-toggle"]') => {
        const t = Array.prototype.slice.call(document.querySelectorAll(e));
        for (let e = 0, s = t.length; e < s; e++) {
          const s = t[e];
          Rt(s);
        }
        ((e = '[data-js*="drawer-close"]') => {
          const t = Array.prototype.slice.call(document.querySelectorAll(e));
          for (let e = 0, s = t.length; e < s; e++)
            t[e].addEventListener("click", Mt, !1);
        })();
      };
    (s(314), s(768));
    const Bt = { ease: "outCubic", duration: 200 },
      jt = "is-open";
    let Pt;
    const Ut = (e) => {
        e.preventDefault();
        const t = e.currentTarget,
          s = t.dataset.rel ? t.dataset.rel : "",
          n = t.classList.contains(jt),
          r =
            "" === s
              ? t.parentNode.nextElementSibling
              : document.querySelector(
                  `[data-js="accordion-cts"][data-rel="${s}"]`,
                );
        if (r)
          if (n) {
            (t.classList.remove(jt),
              ((e, t = {}) => {
                const s = Object.assign({}, Bt, t);
                Ot(e, {
                  ...s,
                  height: "0px",
                  onBegin: () => {
                    e.style.display = "block";
                  },
                  onComplete: () => {
                    ((e.style.display = ""),
                      e.classList.remove("is-open"),
                      e.dispatchEvent(new CustomEvent("slideup.complete")));
                  },
                });
              })(r, Pt));
            const e = new CustomEvent("accordion.close.complete");
            t.dispatchEvent(e);
          } else {
            (t.classList.add(jt),
              ((e, t = {}) => {
                const s = ((e) => {
                    if (!e) return;
                    const t = e.cloneNode(!0);
                    (e.parentNode.appendChild(t),
                      (t.style.cssText =
                        "display:block; height:auto; max-height:none; visibility:hidden;"));
                    const s = t.offsetHeight;
                    return (e.parentNode.removeChild(t), s);
                  })(e),
                  n = Object.assign({}, Bt, t);
                Ot(e, {
                  ...n,
                  height: `${s}px`,
                  onBegin: () => {
                    e.style.display = "block";
                  },
                  onComplete: () => {
                    ((e.style.height = ""),
                      e.dispatchEvent(new CustomEvent("slidedown.complete")));
                  },
                });
              })(r, Pt));
            const e = new CustomEvent("accordion.open.complete");
            t.dispatchEvent(e);
          }
      },
      zt = (e) => {
        (e.addEventListener("click", Ut, !1),
          Pt.callback &&
            Pt.callback.open &&
            e.addEventListener("accordion.open.complete", Pt.callback.open, !1),
          Pt.callback &&
            Pt.callback.close &&
            e.addEventListener(
              "accordion.close.complete",
              Pt.callback.close,
              !1,
            ));
      };
    class Xt {
      constructor(e) {
        ((this.container =
          "string" == typeof e ? document.querySelector(e) : e),
          this.container &&
            ((this.buttons = this.container.querySelectorAll("button")),
            (this.html = document.documentElement),
            this.init()));
      }
      init() {
        const e = localStorage.getItem("fontSizeMode") || "normal";
        (this.apply(e),
          this.buttons.forEach((e) => {
            e.addEventListener("click", () => {
              const t = e.dataset.size;
              (this.apply(t), localStorage.setItem("fontSizeMode", t));
            });
          }));
      }
      apply(e) {
        (this.html.classList.remove("font-normal", "font-large"),
          this.html.classList.add(`font-${e}`),
          this.buttons.forEach((t) => {
            t.classList.toggle("active", t.dataset.size === e);
          }));
      }
    }
    class Yt {
      constructor(e, t = {}) {
        ((this.container =
          "string" == typeof e ? document.querySelector(e) : e),
          this.container &&
            ((this.activeClass = t.activeClass || "active"),
            (this.triggerSelector = t.triggerSelector || "a"),
            (this.closeOnOutside = !1 !== t.closeOnOutside),
            (this.hover = t.hover || !1),
            this.init()));
      }
      init() {
        (this.container.addEventListener("click", (e) => {
          const t = e.target.closest(this.triggerSelector);
          t &&
            (e.preventDefault(),
            this.hover ? this.setActive(t) : this.toggleActive(t));
        }),
          this.hover &&
            this.container.addEventListener("mouseover", (e) => {
              const t = e.target.closest(this.triggerSelector);
              t && this.setActive(t);
            }),
          this.closeOnOutside &&
            document.addEventListener("click", (e) => {
              this.container.contains(e.target) || this.removeAllActive();
            }));
      }
      toggleActive(e) {
        const t = e.classList.contains(this.activeClass);
        (this.removeAllActive(), t || e.classList.add(this.activeClass));
      }
      setActive(e) {
        (this.removeAllActive(), e.classList.add(this.activeClass));
      }
      removeAllActive() {
        this.container
          .querySelectorAll(`.${this.activeClass}`)
          .forEach((e) => e.classList.remove(this.activeClass));
      }
    }
    const Vt = (t) => {
      if (window.__srsCjHeaderInit) return;
      window.__srsCjHeaderInit = 1;
      (t && document.removeEventListener("DOMContentLoaded", Vt, !1),
        document.body.addEventListener("touchstart", function () {}, !1),
        window.addEventListener("scroll", e, !1),
        e(),
        $t(),
        ((e = '[data-js="accordion-toggle"]', t = {}) => {
          const s = document.querySelectorAll(e);
          ((Pt = t), s && Array.prototype.forEach.call(s, zt));
        })(),
        document.addEventListener("DOMContentLoaded", () => {
          document.querySelectorAll(".js-font-size-toggle").forEach((e) => {
            if (e.closest("[hidden]")) return;
            new Xt(e);
          });
        }),
        document.addEventListener(
          "click",
          function (t) {
            var e = t.target.closest('[data-js="change_lang"]');
            if (!e || e.closest("[hidden]")) return;
            t.preventDefault();
            var n = e.closest("form");
            if (!n) return;
            var o = n.getAttribute("action") || "";
            if (
              o.indexOf("localization") < 0 &&
              !n.querySelector('[name="locale_code"]')
            )
              return;
            var s = e.dataset.value || e.getAttribute("data-value") || "";
            if (!s) return;
            var r = n.querySelector('input[name="locale_code"]');
            r ||
              ((r = document.createElement("input")),
              (r.type = "hidden"),
              (r.name = "locale_code"),
              n.appendChild(r));
            var a = n.querySelector('input[name="return_to"]');
            r.value = s;
            a &&
              (a.value =
                window.location.pathname +
                window.location.search +
                window.location.hash);
            typeof n.requestSubmit == "function"
              ? n.requestSubmit()
              : n.submit();
          },
          !1,
        ),
        (function () {
          document.querySelectorAll(".cj-header-bar").forEach(function (t) {
            if (t.closest("[hidden]")) return;
            t.querySelectorAll(".cj-lang").forEach(function (e) {
              if (e.closest("[hidden]") || e.dataset.srsLangInit) return;
              e.dataset.srsLangInit = "1";
              new Yt(e, {
                triggerSelector: ".cj-lang__head",
                activeClass: "active",
                closeOnOutside: !0,
                hover: !0,
              });
            });
          });
        })());
    };
    "loading" !== document.readyState
      ? Vt()
      : document.addEventListener("DOMContentLoaded", Vt, !1);
  })();
})();
